//fetchReportFree
export default {
  namespaced: true,
  state: {
    report_list: []
  },
  mutations: {
    resetState(state) {
      state.report_list = [];
    },
    getReportList(state, data) {
      state.report_list = data;
    }
  },
  actions: {
    async getReportList({ commit, rootState, dispatch }, data_search) {
      let url =
        rootState.api_urls.fetchReportFree_getReportList_new +
        data_search.store_id +
        "/" +
        data_search.status_id +
        "/" +
        data_search.date_start +
        "/" +
        data_search.date_end;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("getReportList", res);
      }
    }
  },
  getters: {}
};
